import React from 'react';
import { useNavigate } from 'react-router-dom';
import style from './SimpleListItem.module.scss';

type SimpleListItemProps = {
  children: React.ReactNode;
  link?: string;
};
export function SimpleListItem({ children, ...props }: SimpleListItemProps): React.JSX.Element {
  const navigate = useNavigate();

  const handleClick = (): void => {
    if (props.link) {
      navigate(props.link, { replace: false });
    }
  };

  return (
    <div
      className={[style.ListItem, 'flex w-100 p-3', props.link ? style.ListItemClickable : ''].join(' ')}
      onClick={handleClick}
    >
      <div>{children}</div>
    </div>
  );
}
